/* @flow */

import React from 'react';
import { displayPrice } from 'app/utils/priceUtils';
import { useGlamor } from 'app/glamor';
import t from 'app/utils/translate';
import DiscountPromo from 'app/components/commons/DiscountPromo';
import CurrencyIcon from 'app/components/commons/CurrencyIcon';

type Props = {
  classes: Object,
  cost?: number,
  discount?: number,
  reducedCost?: number,
  showLabel?: boolean,
};

const defaultProps = {
  cost: undefined,
  discount: 0,
  reducedCost: 0,
  showLabel: true,
};

function ChallengeFeeField({ classes, cost, discount, reducedCost, showLabel }: Props) {
  if (discount === 0) {
    return (
      <div className={classes.fieldWrapper}>
        {cost !== undefined && (
          <div className={classes.standardCost}>
            {showLabel && <span className={classes.label}>{t('Entry')}: </span>}
            {cost > 0 && <CurrencyIcon />}
            {displayPrice(cost)}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={classes.fieldWrapper}>
      <DiscountPromo discount={discount} />
      <div className={classes.costDetails}>
        <div className={classes.standardCost}>
          {showLabel && <span className={classes.label}>{t('Entry')}: </span>}
          <span className={classes.originalCost}>{displayPrice(cost)}</span>
        </div>
        <div className={classes.reducedCost}>
          {reducedCost > 0 && <CurrencyIcon />}
          {displayPrice(reducedCost)}
        </div>
      </div>
    </div>
  );
}

ChallengeFeeField.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    costDetails: {
      lineHeight: 1,
      [theme.mediaQuery.mobileOnly]: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'flex-end',
      },
    },
    fieldWrapper: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      [theme.mediaQuery.desktopAndUp]: {
        flexDirection: 'row',
      },
      [theme.mediaQuery.mobileOnly]: {
        flexDirection: 'column-reverse',
      },
    },
    originalCost: {
      color: theme.color.basis5,
      textDecoration: 'line-through',
      [theme.mediaQuery.desktopAndUp]: {
        fontSize: '0.75em',
      },
    },
    reducedCost: {
      lineHeight: 1.2,
      [theme.mediaQuery.mobileOnly]: {
        marginRight: theme.spacing.tiny,
      },
    },
    standardCost: {
      whiteSpace: 'nowrap',
      [theme.mediaQuery.desktopAndUp]: {
        fontSize: 'inherit',
      },
    },
    label: {
      [theme.mediaQuery.desktopAndUp]: {
        display: 'none',
      },
    },
  };
}

export default useGlamor(applyStyles)(ChallengeFeeField);
